import { render, staticRenderFns } from "./Subconverter.vue?vue&type=template&id=224651bc"
import script from "./Subconverter.vue?vue&type=script&lang=js"
export * from "./Subconverter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports